'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _paths = require('ifeis-isomorphic/lib/redux/actions/events/paths');

var _paths2 = require('ifeis-isomorphic/lib/redux/actions/comments/paths');

var _paths3 = require('ifeis-isomorphic/lib/redux/actions/dress-checks/paths');

var _paths4 = require('ifeis-isomorphic/lib/redux/actions/schools/paths');

var _paths5 = require('ifeis-isomorphic/lib/redux/actions/adjudicators/paths');

var _paths6 = require('ifeis-isomorphic/lib/redux/actions/person/paths');

var _paths7 = require('ifeis-isomorphic/lib/redux/actions/feiseanna/paths');

var _immutable = require('immutable');

function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

exports.default = function (school_id, feis_id) {
  return function (state) {
    if ((0, _paths4.schoolCompetitorsAreLoading)(state, school_id)) {
      return { loading: true, competitors: [] };
    }

    var loading = false;
    var competitors = (0, _paths4.getSchoolCompetitors)(state, school_id, feis_id).filter(function (pid) {
      return (0, _paths7.getFlagsForPerson)(state, feis_id, pid).getIn(['registered']);
    }).filter(function (pid) {
      if ((0, _paths6.commentsForPersonInEventAreLoading)(state, pid)) {
        loading = true;
        return false;
      }
      return true;
    }).filter(function (pid) {
      if ((0, _paths.getParticipatedEventsForScoring)(state, feis_id, pid).size === 0) {
        loading = false;
        return false;
      }
      return true;
    }).map(function (pid) {
      var participatedEvents = (0, _paths.getParticipatedEventsForScoring)(state, feis_id, pid);
      var commentDetails = participatedEvents.map(function (eid) {
        var comments = (0, _paths6.getCommentsForPersonInEvent)(state, eid, pid).map(function (cid) {
          return (0, _paths2.getComment)(state, cid) || (0, _immutable.Map)();
        }).reduce(function (accum, comment) {
          var matchingAdjudicatorRecord = accum.find(function (a) {
            return a.get('adj_id') === comment.get('adj_id');
          });
          if (!matchingAdjudicatorRecord) {
            return accum.push(comment);
          } else {
            return accum.filter(function (a) {
              return a.get('adj_id') !== comment.get('adj_id');
            }).push(comment);
          }
        }, (0, _immutable.List)());

        var event = (0, _paths.getEvent)(state, eid);
        var placement = (0, _paths.getPlacementForPersonInEvent)(state, eid, pid);

        var dressCheckIdsByAdjudicator = Object.values(((0, _paths6.getDressCheckAdjForPersonInEvent)(state, eid, pid) || (0, _immutable.Map)()).toJS());

        var dressChecksForPersonAndEvent = dressCheckIdsByAdjudicator.map(function (dressCheckIdByAdjudicator) {
          return (0, _paths3.getDressCheck)(state, dressCheckIdByAdjudicator);
        });

        var adjIds = (0, _immutable.fromJS)([].concat(_toConsumableArray(new Set(comments.map(function (comment) {
          return comment.get('adj_id');
        }).concat(dressChecksForPersonAndEvent.map(function (dress) {
          return dress.get('adj_id');
        }))))));

        var adjs = adjIds.map(function (aid) {
          return (0, _paths5.adjudicators)(state, aid);
        });

        return { event: event, comments: comments, adjudicators: adjs, placement: placement, dressChecks: dressChecksForPersonAndEvent };
      });

      var competitor = (0, _paths6.getPerson)(state, pid);
      return { competitor: competitor, comments: commentDetails };
    });

    return { loading: loading, competitors: competitors };
  };
};


//////////////////
// WEBPACK FOOTER
// ./routes/feiseanna/one/school-results-for-teachers/mapStateToController.js
// module id = 598
// module chunks = 0